import React from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import MainTitle from "../../../components/ui/MainTitle";
import SubmitButton from "../../../components/form/SubmitButton";
import { useUpdateResource } from "../../../hooks/useUpdateResource";
import { useTranslation } from "react-i18next";
import LoadingButton from "../../../components/form/LoadingButton";
import SectorForm, { SectorFormData } from "../../../components/admin/sectors/SectorForm";

export default function AdminAddSectorPage() {
  const navigate = useNavigate();

  const { register, handleSubmit, formState: { errors } } = useForm<SectorFormData>({
    defaultValues: {
      languages: [
        { languageCode: "en", title: "" },
        { languageCode: "ar", title: "" },
      ],
    },
  });


   const { t } = useTranslation();
  const { loading, updateResource } = useUpdateResource();

  const onSubmit = (data: SectorFormData) => {
    const languages = data.languages.map(da=>({languageCode:da.languageCode,name:da.title}));
    updateResource(`sector/create`, {languages},
        "admin",{
            method: "POST",
            successMessage: t("createdSuccess"),
            invalidateQueries:["sectors-by-admin"],
            navigateAfter: () => navigate(`/admin/sectors`),
          });
  };

  return (
    <div className="p-6 container">
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4 w-full">
        <MainTitle title="add_new_sector" />
        <SectorForm register={register} errors={errors} />
        {
        loading?
        <LoadingButton height={64}/> 
        :
        <SubmitButton height={64} label="create" />
        }
      </form>
    </div>
  );
}
